<div class="w-full h-full text-bluegrey-2 font-inter relative">
    @for (timeslot of timeslots; track timeslot; let i = $index) {
        @if (i % 4 == 0) {
            <div
                class="text-[12px] leading-[10px] right-0 font-medium absolute"
                [style.top.px]="i * 48"
                >{{ timeslot }}</div
            >
        } @else {
            <div
                class="text-[10px] right-0 leading-3 font-semibold tracking-[.48px] absolute"
                [style.top.px]="i * 48 - 4"
                >{{ timeslot }}</div
            >
        }
    }
</div>
